import { Button } from '@chakra-ui/react';

import { LoginCredentials } from '../../api/types';

import schema from './schema';

import { Link } from '@/components/common/Link';
import { FieldWrapper, Form, TextInput } from '@/components/Form';
import * as LC from '@/components/LC';

type LoginFormProps = {
  loginLoading: boolean;
  login: (props: any) => void;
};

export const LoginForm = ({ loginLoading, login }: LoginFormProps) => {
  return (
    <Form<LoginCredentials>
      initialValues={{
        email: '',
        password: '',
        registrationToken: 'registrationToken',
        operatingSystem: 'windows',
      }}
      onSubmit={(values) => {
        login(values);
      }}
      validationSchema={schema}
    >
      {() => (
        <LC.Vertical w="100%">
          <FieldWrapper
            name="email"
            required
            label="E-mail"
            as={(props) => <TextInput type="email" {...props} />}
          />
          <FieldWrapper
            name="password"
            required
            label="Senha"
            as={(props) => <TextInput type="password" {...props} />}
          />

          <LC.Vertical center spaceBetween>
            <Button size="sm" as={Link} to="../cadastro" mb={4} variant="ghost">
              Não tem uma conta?
            </Button>
            <Button
              isLoading={loginLoading}
              type="submit"
              className="w-full"
              variant="@primary"
              w="100%"
            >
              Entrar
            </Button>
          </LC.Vertical>
        </LC.Vertical>
      )}
    </Form>
  );
};
